import type { StateStorage } from "zustand/middleware";

/** 저장 매체 접근이 throw 되는 환경(시크릿 모드·스토리지 차단)에서 예외가 새지 않게 한다 — 실패 시 in-memory(다음 실행에 초기화되는 수준의 손실). zustand persist 의 createJSONStorage(createSafeStorage) 로 쓴다. 도메인 무관 인프라라 shared 에 둔다. */
export const createSafeStorage = (): StateStorage => {
  try {
    const probe = "__mt_safe_storage_probe__";
    window.localStorage.setItem(probe, "1");
    window.localStorage.removeItem(probe);
    return window.localStorage;
  } catch {
    const memory = new Map<string, string>();
    return {
      getItem: (name) => memory.get(name) ?? null,
      setItem: (name, value) => {
        memory.set(name, value);
      },
      removeItem: (name) => {
        memory.delete(name);
      },
    };
  }
};
